import React from 'react';
import IconFilter from '../../../components/images/IconFilter';
import IconFilterArrows from '../../../components/images/IconFilterArrows';

const TicketsFiltersButtons = ({ showFilter, setShowFilter, isAscending, setIsAscending }) => {
    return (
        <div className='flex items-center gap-2'>
            <button
                onClick={() => setShowFilter((prev) => !prev)}
                className={`rounded-full w-[32px] h-[32px] flex justify-center items-center ${showFilter ? 'bg-theme1-primary2' : 'bg-theme1-tan'}`}
            >
                <IconFilter className={`${showFilter ? 'fill-white' : 'fill-theme1-primary2'}`} />
            </button>
            <button
                onClick={() => setIsAscending((prev) => !prev)}
                className={`rounded-full w-[32px] h-[32px] flex justify-center items-center ${isAscending ? 'bg-theme1-primary2' : 'bg-theme1-tan'}`}
            >
                <IconFilterArrows className={`${isAscending ? 'fill-white' : 'fill-theme1-primary2'}`} />
            </button>
        </div>
    );
};

export default TicketsFiltersButtons;
